export const TEN_MINUTE_LABELS = [
    '05:00', '05:10', '05:20', '05:30', '05:40', '05:50',
    '06:00', '06:10', '06:20', '06:30', '06:40', '06:50',
    '07:00', '07:10', '07:20', '07:30', '07:40', '07:50',
    '08:00', '08:10', '08:20', '08:30', '08:40', '08:50',
    '09:00', '09:10', '09:20', '09:30', '09:40', '09:50',
    '10:00', '10:10', '10:20', '10:30', '10:40', '10:50',
    '11:00', '11:10', '11:20', '11:30', '11:40', '11:50',
    '12:00', '12:10', '12:20', '12:30', '12:40', '12:50',
    '13:00', '13:10', '13:20', '13:30', '13:40', '13:50',
    '14:00', '14:10', '14:20', '14:30', '14:40', '14:50',
    '15:00', '15:10', '15:20', '15:30', '15:40', '15:50',
    '16:00', '16:10', '16:20', '16:30', '16:40', '16:50',
    '17:00', '17:10', '17:20', '17:30', '17:40', '17:50',
    '18:00', '18:10', '18:20', '18:30', '18:40', '18:50',
    '19:00', '19:10', '19:20', '19:30', '19:40', '19:50',
    '20:00',
  ];
  
  export const HOURLY_LABELS = TEN_MINUTE_LABELS.filter((label) => label.endsWith(':00'));
  
  export const MAX_HOURLY_RANGE_DAYS = 7;
  
  export const formatDateKST = (date) =>
    new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split('T')[0];
  
  /** created_at 문자열에서 시각(분) 추출 — GMT/로컬/MySQL 형식 공통 */
  export const parseTimeMinutesFromCreatedAt = (createdAt) => {
    const str = String(createdAt ?? '');
    const timeMatch = str.match(/(\d{1,2}):(\d{2})(?::\d{2})?/);
    if (timeMatch) {
      return Number(timeMatch[1]) * 60 + Number(timeMatch[2]);
    }
  
    const dateObj = new Date(createdAt);
    if (!Number.isNaN(dateObj.getTime())) {
      return dateObj.getUTCHours() * 60 + dateObj.getUTCMinutes();
    }
  
    return null;
  };
  
  export const isWithinTimeRange = (createdAt, targetTime) => {
    const [targetHours, targetMinutes] = targetTime.split(':').map(Number);
    const itemTimeMinutes = parseTimeMinutesFromCreatedAt(createdAt);
    if (itemTimeMinutes === null) return false;
  
    const startTime = targetHours * 60 + targetMinutes;
    const endTime = startTime + 10;
  
    return itemTimeMinutes >= startTime && itemTimeMinutes < endTime;
  };
  
  export const findClosestTimeData = (filteredData, targetTime) => {
    const closestData = filteredData.find((item) =>
      isWithinTimeRange(item.created_at, targetTime)
    );
  
    if (!closestData) {
      return { value: 0, item: null };
    }
  
    return { value: closestData.Grid_Power, item: closestData };
  };
  
  export const buildHourlySlots = (dates) => {
    const slots = [];
  
    dates.forEach((date) => {
      const dateStr = formatDateKST(date);
      const shortDate = dateStr.slice(5);
  
      HOURLY_LABELS.forEach((hour) => {
        slots.push({
          date: dateStr,
          hour,
          label: `${shortDate} ${hour}`,
        });
      });
    });
  
    return slots;
  };
  